import { render, staticRenderFns } from "./MediaRecord.vue?vue&type=template&id=efaedc08&"
import script from "./MediaRecord.vue?vue&type=script&lang=js&"
export * from "./MediaRecord.vue?vue&type=script&lang=js&"
import style0 from "./MediaRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports